module.exports = __webpack_public_path__ + "img/full3-min.c3d6087e.png";